export const environment = {
    localhost: {
      domain: 'dev-0tc6bn14.eu.auth0.com',
      domainURL: 'https://dev-0tc6bn14.eu.auth0.com',
      audience: 'https://driving-olsapi-service.cms-uat.yukon.ca/api/',
      client_id: 'HnymDpqC7ZdAxvJOCZIw56jlsElyeslI',
      client_secret: '',
      response_type: 'code',
      response_mode: 'query',
      redirect_uri: 'https://driving-payment-test.cms-uat.yukon.ca/oidc-callback.html',
      scope: 'openid profile email',
      post_logout_redirect_uri: 'https://driving-payment-test.cms-uat.yukon.ca/signed-out',
    }
}
